<div class="text-accordion">
  <ng-content></ng-content>
</div>
